<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入供应商</span>
    </template>
    <template #content>
      <gj-upload
          :template-url="`/supply/supplier/download/import/template`"
          @uploadAfter="uploadAfter"
          container-type="supplierManager"
          style="margin-bottom: 12px;"
      >
        <template #tip>
          <span>只能上传xls/xlsx文件</span>
        </template>
      </gj-upload>
      <gj-import-alert
          :rules="[
            '重复导入同个供应商数据将覆盖原有数据',
            '同一个供应商名称且同一个供应商编码存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin, userGuideMixin} from "../../../../../minxins";
  import {importSupplier} from "../../../../../api/purchase";

  export default {
    name: "supplier-import",
    mixins: [modalMixIn, uploadMixin, userGuideMixin],
    methods: {
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        importSupplier(attId)
          .then((res) => {
            this.$gjImportHandle(res, uploadCb);
            this.$emit('userGuide');
          }).catch(() => {
            uploadCb('error')
          }).complete(() => this.importHandleLoading = false)
      }
    }
  }
</script>

<style scoped>

</style>
